module.exports = __webpack_public_path__ + "img/img3.a6bf4cae.png";